export default __webpack_public_path__ + "static/BeAIReadyLogo-White-2f14fca8b968838e7792cb0630c0df0b.svg";